import { addHandlerClickOnCompareIcon } from './compare';

let timer = null;

const formDataToObj = (formData) => {
  const keys = [...formData.keys()];
  const dataObj = {};

  keys.forEach((key) => {
    if (formData.get(key)) {
      dataObj[key] = formData.get(key);
    }
  });

  return dataObj;
};

const fetchFiltersUrl = async (rawData) => {
  const URL = `${window.location.origin}${window.location.pathname}`;
  const data = {
    ajax: 'y',
    ...rawData,
  };

  try {
    const rawResponse = await fetch(
      `${URL}?${new URLSearchParams(data)}`,
      { method: 'POST' },
    );

    const responseToString = await rawResponse.text();
    const response = await JSON.parse(responseToString.replaceAll("'", '"'));

    return response;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    return null;
  }
};

const moveFilter = () => {
  const filterPopBody = document.querySelector('.filter-popup__content');
  const filter = document.querySelector('aside.popup_filter');

  if (filterPopBody && filter && window.innerWidth < 768) {
    filterPopBody.prepend(filter);
  }
};
window.moveFilterFunc = moveFilter;

const getNewPageContent = async (URL) => {
  const formData = new FormData();
  formData.append('filter-ajax', 'Y');
  const formatedData = new URLSearchParams(formData);

  try {
    const rawResponse = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formatedData,
    });

    const responseToString = await rawResponse.text();
    return responseToString;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);

    return null;
  }
};

const addNewNode = (node) => {
  const container = document.querySelector('[data-ajax="catalog"]');

  if (container) {
    const parent = container.closest('.page');
    if (parent) parent.innerHTML = node;
  }
};

const initNewNodes = () => {
  queueMicrotask(() => {
    window.loyaltyProgramInit();
    window.initFilter();
    window.initBuyScript();
    addHandlerClickOnCompareIcon();
    window.addHandlerClickOnFavoriteIcon();
    window.lazyUpdate();
    window.initShowMoreScript();
    window.spollerUpd();
    window.initSlimSelect();
    window.initSmartFilterToggler();
    window.dropCatalogInit();
    moveFilter();
  });
};

const sendNewFiltersReq = async (form) => {
  const formData = new FormData(form);
  const data = formDataToObj(formData);

  window.loaderShow('.catalog-lvl-three');

  const response = await fetchFiltersUrl(data);
  let { FILTER_AJAX_URL } = response;

  const hasParams = FILTER_AJAX_URL.indexOf('/?') !== -1;
  if (hasParams) {
    FILTER_AJAX_URL = FILTER_AJAX_URL.slice(0, FILTER_AJAX_URL.indexOf('/?') + 1);
  }

  const pageContent = await getNewPageContent(FILTER_AJAX_URL);
  if (pageContent) {
    addNewNode(pageContent);
    initNewNodes();

    const params = window.location.search;
    FILTER_AJAX_URL += params;
    const state = {
      isFilterPage: true,
      html: pageContent,
      url: FILTER_AJAX_URL,
    };
    window.history.pushState(state, null, FILTER_AJAX_URL);

    if (window.location.pathname.includes('favorites/catalog')) {
      window.setActiveFavoriteIcons();
    }

    window.SwitchView.init();
  }
};

const filterInputListener = async (evt) => {
  const target = evt.target.nodeName === 'INPUT'
    ? evt.target
    : evt.target.closest('input');

  if (target.type === 'number') {
    clearTimeout(timer);
    timer = setTimeout(() => {
      sendNewFiltersReq(target.form);
    }, 1000);
  } else {
    sendNewFiltersReq(target.form);
  }
};

window.addEventListener('popstate', (evt) => {
  if (evt.state?.isFilterPage) {
    addNewNode(evt.state.html);
    initNewNodes();
  }
});

const initFilter = () => {
  const filterBlock = document.querySelector('.filter__body');
  let inputs = null;
  if (filterBlock) {
    inputs = filterBlock.querySelectorAll('input');
  }

  if (inputs) {
    inputs.forEach((input) => {
      if (input.type && input.type === 'number') {
        input.addEventListener('keyup', filterInputListener);
      }

      if (input.type && (input.type === 'checkbox' || input.type === 'radio')) {
        input.addEventListener('click', filterInputListener);
      }
    });

    const filterForm = filterBlock.closest('form.filter');
    if (filterForm && !filterForm.classList.contains('_init')) {
      filterForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const { href: URL } = window.location;
        if (URL.includes('filter/')) {
          let formattedURL = `${URL.slice(0, URL.indexOf('filter/') + 7)}clear/apply/`;

          const pageContent = await getNewPageContent(formattedURL);
          if (pageContent) {
            addNewNode(pageContent);
            initNewNodes();

            const params = window.location.search;
            formattedURL += params;
            const state = {
              isFilterPage: true,
              html: pageContent,
              url: formattedURL,
            };
            window.history.pushState(state, null, formattedURL);

            if (window.location.pathname.includes('favorites/catalog')) {
              window.setActiveFavoriteIcons();
            }

            window.SwitchView.init();

            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
        }

        filterForm.classList.add('_init');
      });
    }
  }

  moveFilter();
};

initFilter();

window.initFilter = initFilter;
